var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2412_2594)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90213 1.91162L9.90213 19.8434H17.1324L17.1324 1.91162L9.90213 1.91162ZM-0.0576172 0.547089V19.8752V21.2079V40.536H-0.0572891V40.5361H39.9317V0.547089H39.9316H18.4969H17.1327H9.9017H8.5376H-0.0572891H-0.0576172ZM8.53716 39.1715L1.30724 39.1715V21.2397H8.53717L8.53716 39.1715ZM1.30724 19.8434H8.53716L8.53717 1.91162L1.30724 1.91162V19.8434ZM38.5671 1.91162H18.4972V13.4219H38.5671V1.91162ZM18.4972 14.7864V26.2967H38.5671V14.7864H18.4972ZM17.1324 21.2397H9.90213L9.90213 39.1715H17.1324L17.1324 21.2397ZM18.4972 39.1715V27.6613H38.5671V39.1715H18.4972Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_2594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.47934)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7A);
export default __webpack_public_path__ + "static/media/7a.d10fe46331c8d2504250d97207999120.svg";
export { ForwardRef as ReactComponent };